// src/components/ChatbotComponent.js
import React, {useState} from "react";
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";

import config from "./config";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider"

import '../../App.css'
import { useLocation } from "react-router-dom";

const ChatbotComponent = () => {
    const [isBotOpen, setIsBotOpen] = useState(false);
    const location = useLocation();

    // Ocultar el botón si la ruta actual es "/login"
    if (location.pathname === "/login") {
        return null;
    }else if (location.pathname === "/admin"){
        return null;
    }


    return (
        <div>
            {isBotOpen && (
                <div style={{position: "fixed", bottom: "80px", right: "20px"}}>
                    <Chatbot
                        config={config}
                        headerText={"Asistente Virtual Fabrizzio"}
                        placeholderText={"Escribe tu mensaje..."}
                        messageParser={MessageParser}
                        actionProvider={ActionProvider}
                    />
                </div>
            )}
            <button
                onClick={() => setIsBotOpen(!isBotOpen)}
                style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    backgroundColor: "#d90e75",
                    color: "white",
                    borderRadius: "50%",
                    border: "none",
                    width: "60px",
                    height: "60px",
                    cursor: "pointer",
                    fontSize: "20px",
                }}
            >
                <i className="bi bi-chat-dots" style={{fontSize: "24px"}}></i>
            </button>
        </div>
    );
};

export default ChatbotComponent;
